export default __webpack_public_path__ + "static/media/file-white.a5345038.svg";